/* global angular, _, $ */
angular.module('ua5App.single')
    .config(['$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {
        $stateProvider.state('single', {
            url: '/single/:slug/',
            templateUrl: 'states/single/single.html',
            controller: 'SingleCtrl',
            controllerAs: 'ctrl',
            params: {
                referrer: 'home',
                date: false
            },
            resolve: {
                post: ['PostFactory', '$stateParams', function(PostFactory, $stateParams) {
                    return PostFactory.post().get({slug: $stateParams.slug}).$promise;
                }]
            }
        });
        $stateProvider.state('info', {
            url: '/info/:tour/:guests/',
            templateUrl: 'states/single/info.html',
            controller: 'InfoCtrl',
            controllerAs: 'ctrl'
        });
    }])
    .controller('InfoCtrl', ['$scope', 'MetaFactory', '$stateParams', function($scope, MetaFactory, $stateParams) {
        $scope.tour = decodeURIComponent($stateParams.tour);
        $scope.guests = $stateParams.guests;
        $scope.print = function() {
            window.print();
        };
    }])
    .controller('SingleCtrl', ['$scope', 'post', 'MetaFactory', '$stateParams', function($scope, post, MetaFactory, $stateParams) {
        var metaData;
        $scope.content = post;
        $scope.referrer = $stateParams.referrer ? $stateParams.referrer : 'home';
        $scope.referrerDate = $stateParams.date ? $stateParams.date : false;
        $scope.referrerTitle = 'Updates';

        function processTime(t) {

            var tArr,
                hour,
                minute,
                defaultTime = '12:00:00';

            if (!t || t === '') {
                // default to noon
                return defaultTime;
                //return false;
            }

            t = t.toLowerCase();
            tArr = t.replace(/./g, '').split(':');
            hour = parseInt(tArr.length > 1 ? tArr[0] : t, 10);
            minute = tArr.length > 1 ? parseInt(tArr[1], 10) : 0;

            // 12 oclock is really 0 oclock
            hour = hour === 12 ? 0 : hour;

            if (t.indexOf('pm') > -1) {
                hour += 12;
            }

            //final check for a valid time
            if (hour < 0 || hour > 24 || minute < 0 || minute > 60) {
                // if invalid time, just return noon
                return defaultTime;
            }

            return hour + ':' + minute + ':00';
        }

        if ($scope.referrer === 'calendar') {
            $scope.referrerTitle = 'Calendar';
        }

        if (post.category.toLowerCase() === 'event') {

            var daysWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            var monthsShort = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'];
            var startTime;
            var startDate;
            var endDate;
            $scope.eventData = angular.fromJson(post.event_data);   // jshint ignore:line

            if (!$scope.eventData.endDate) {
                $scope.eventData.endDate = $scope.eventData.startDate;
            }

            // adding PDT cus this is all ucla time
            startTime = processTime($scope.eventData.startTime);
            startDate = new Date($scope.eventData.startDate + (startTime ? (' ' + startTime) : ''));
            endDate = ($scope.eventData.startDate === $scope.eventData.endDate) ? false : new Date($scope.eventData.endDate + (startTime ? (' ' + startTime) : ''));

            $scope.displayDate = {};
            $scope.displayDate.dayWeekStart = daysWeek[startDate.getDay()];
            $scope.displayDate.dateStart = monthsShort[startDate.getMonth()] + ' ' + startDate.getDate() + ', ' + startDate.getFullYear();
            $scope.displayDate.timeStart = ($scope.eventData.startTime && $scope.eventData.startTime !== '') ? $scope.eventData.startTime : false;
            $scope.displayDate.dateEnd = endDate && (endDate !== startDate) ? monthsShort[endDate.getMonth()] + ' ' + endDate.getDate() + ', ' + endDate.getFullYear() : false;

            if (!endDate) {
                // abitrariliy make events 2 hrs if no end time
                endDate = new Date (startDate);
                endDate.setHours(startDate.getHours() + 2);
            }

            $scope.displayDate.google = {};
            $scope.displayDate.google.start = startDate.toJSON().replace(/-|:|.000/g, '');
            $scope.displayDate.google.end = endDate.toJSON().replace(/-|:|.000/g, '');

            if (endDate && (endDate !== startDate) && (!$scope.eventData.startTime || $scope.eventData.startTime === '')) {
                //make multiday events with no start time -> all-day
                $scope.displayDate.google.start = $scope.displayDate.google.start.split('T')[0];
                $scope.displayDate.google.end = $scope.displayDate.google.end.split('T')[0];
            }
        } else if (post.category.toLowerCase() === 'newsletter') {
            $scope.referrerTitle = 'Newsletter';
            $scope.referrer = 'home({category: "newsletter"})';
        }

        metaData = {
            title: post.title,
            description: post.summary
        };

        if (
            $scope.content.hasOwnProperty('image') &&
            typeof $scope.content.image === 'string'
        ) {
            metaData.image = location.protocol + '//di79x7a4whson.cloudfront.net' + $scope.content.image;
        }

        if ($scope.content.post_data !== '' && !_.isUndefined($scope.content.post_data)) {
            $scope.content.post_data = $.parseJSON($scope.content.post_data);
            if ($scope.content.post_data !== null) {
                $scope.content.slideshow = $scope.content.post_data.slideshow.reverse();
            }
        }

        MetaFactory.set(metaData);

        $scope.windowpop = function(url, width, height) {
            var leftPosition, topPosition;
            //Allow for borders.
            leftPosition = (window.screen.width / 2) - ((width / 2) + 10);
            //Allow for title and status bars.
            topPosition = (window.screen.height / 2) - ((height / 2) + 50);
            //Open the window.
            window.open(url, 'Window2', 'status=no,height=' + height + ',width=' + width + ',resizable=yes,left=' + leftPosition + ',top=' + topPosition + ',screenX=' + leftPosition + ',screenY=' + topPosition + ',toolbar=no,menubar=no,scrollbars=no,location=no,directories=no');
            return false;
        };
    }])
;
